import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Truck, Clock, ArrowUpRight } from 'lucide-react';
import { DELIVERY_AREAS, CONTACT, LOCATIONS } from '../mock';
import Reveal from './Reveal';

export default function DeliveryAreas() {
  return (
    <section id="delivery-areas" className="py-20 lg:py-24 bg-[#F1ECE3]">
      <div className="max-w-5xl mx-auto px-5 lg:px-8 text-center">
        <Reveal>
          <span className="text-[13px] tracking-[0.3em] uppercase text-[#C4715A] font-medium">Where We Deliver</span>
          <h2 className="font-serif-display text-[32px] sm:text-[42px] text-[#26302a] mt-3 leading-tight max-w-3xl mx-auto">
            Same-Day Flower Delivery for Menlo Park &amp; Surrounding Areas
          </h2>
          <p className="mt-5 text-[16px] leading-relaxed text-[#5A554C] max-w-3xl mx-auto">
            Looking for <strong className="font-semibold text-[#3D5142]">same-day flower delivery for Menlo Park and surrounding areas</strong>?
            We are a real local florist based in Redwood City, hand-arranging fresh bouquets and delivering them the very same day
            across Menlo Park, Atherton, Palo Alto, Woodside, Portola Valley and the greater San Francisco Bay Area. Order before
            2:00 PM and we will bring your flowers straight to the door — for birthdays, anniversaries, sympathy, or just because.
          </p>
        </Reveal>

        {/* Trust row */}
        <Reveal delay={80}>
          <div className="mt-8 flex flex-wrap justify-center gap-x-8 gap-y-3">
            {[
              { icon: Truck, label: 'Same-day delivery in Menlo Park' },
              { icon: Clock, label: 'Order before 2 PM' },
              { icon: MapPin, label: 'Local florist since 1994' },
            ].map((f) => (
              <span key={f.label} className="inline-flex items-center gap-2 text-[14px] text-[#3D5142]">
                <f.icon className="w-4 h-4 text-[#C4715A]" /> {f.label}
              </span>
            ))}
          </div>
        </Reveal>

        <Reveal delay={100}>
          <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
            {LOCATIONS.map((l) => (
              <Link key={l.slug} to={`/flower-delivery/${l.slug}`} className="group flex items-center gap-3 bg-white border border-[#E5DCCF] rounded-2xl px-5 py-4 text-left hover:border-[#3D5142] hover:shadow-[0_10px_30px_rgba(61,81,66,0.1)] transition-all">
                <span className="shrink-0 w-10 h-10 rounded-xl bg-[#EDE7DC] flex items-center justify-center"><MapPin className="w-5 h-5 text-[#3D5142]" /></span>
                <span className="flex-1 min-w-0">
                  <span className="block font-serif-display text-[16px] text-[#2A2A28] leading-tight">{l.city}</span>
                  <span className="block text-[12.5px] text-[#8A7C6A]">Same-day delivery · {l.zip}</span>
                </span>
                <ArrowUpRight className="w-4.5 h-4.5 text-[#B0A692] group-hover:text-[#C4715A] transition-colors" />
              </Link>
            ))}
          </div>
        </Reveal>

        <Reveal delay={140}>
          <div className="flex flex-wrap justify-center gap-2.5 mt-8">
            {DELIVERY_AREAS.map((a) => (
              <span key={a} className="inline-flex items-center gap-1.5 bg-white border border-[#E5DCCF] rounded-full px-4 py-2 text-[14px] text-[#4A4A45] hover:border-[#3D5142] hover:text-[#3D5142] transition-colors">
                <MapPin className="w-3.5 h-3.5 text-[#C4715A]" /> {a}
              </span>
            ))}
          </div>
        </Reveal>

        <Reveal delay={160}>
          <p className="mt-8 text-[15px] text-[#6A655C]">
            Not sure if we reach you? Call us at{' '}
            <a href={CONTACT.phoneHref} className="text-[#C4715A] font-medium underline underline-offset-4 hover:text-[#a95a45]">{CONTACT.phone}</a>{' '}
            — we can often arrange same-day delivery beyond our standard zones.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
